import React, { useContext, useState } from "react";

import Modal from "../ui-components/Modal";
import { useIntl } from "react-intl";
import CountryConfigContext from "../CountryConfigContext";
import { NotificationsContext } from "../ui-components/Notifications";
import useCountryAxiosInstance from "../hooks/useCountryAxiosInstance";
import Input from "../ui-components/Input";
import getLocale from "../api/getLocale";
import convertLocale from "../utils/convertLocale";
import Button from "../ui-components/Button";
import CountryContext from "../CountryContext";
import { useParams } from "react-router-dom";
import getServiceLocale from "../api/getServiceLocale";

const ServiceConfiguratorCreateTranslation = ({
  setCreateTranslation,
  createTranslation,
  setServiceLocale,
}) => {
  const { serviceId } = useParams();
  const intl = useIntl();
  const { country } = useContext(CountryContext);
  const { config, setConfig } = useContext(CountryConfigContext);
  const { push } = useContext(NotificationsContext);
  const [loading, setLoading] = useState(false);
  const apiRequest = useCountryAxiosInstance();
  const [translation, setTranslation] = useState("");

  return (
    <Modal fixed>
      <div className="flex-col">
        <div className="flex justify-between mb-4">
          <div>
            <p>CODE</p>
          </div>
          <div>
            <p className="font-bold uppercase">{createTranslation.key}</p>
          </div>
        </div>
        <div className="flex justify-between mb-4">
          <div>
            <p>LOCALE</p>
          </div>
          <div>
            <p className="font-bold uppercase">{createTranslation.locale}</p>
          </div>
        </div>

        <Input
          value={translation}
          onChange={(e) => {
            setTranslation(e.target.value);
          }}
          label={"ENTER TRANSLATION"}
          type="text"
          errorMessage="Missing translation"
          required
        />
        <div className="flex justify-between">
          <Button
            styleType="secondary"
            disabled={loading}
            onClick={() => {
              setCreateTranslation(null);
            }}
          >
            CANCEL
          </Button>
          <Button
            submitting={loading}
            onClick={async () => {
              try {
                setLoading(true);
                await apiRequest.post(`/locale`, {
                  ...createTranslation,
                  w_perm: ["admin"],
                  value: translation,
                  service: serviceId,
                  r_perm: [],
                });
                const locale = await getLocale(country);
                const serviceLocale = await getServiceLocale(
                  country,
                  serviceId
                );
                setServiceLocale(serviceLocale.data);
                setConfig({
                  ...config,
                  locale: convertLocale(locale.data),
                });
                setCreateTranslation(null);
              } catch (error) {
                setLoading(false);

                push({
                  title: intl.formatMessage({ id: "server_error" }),
                  type: "error",
                });
              }
            }}
          >
            SAVE
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ServiceConfiguratorCreateTranslation;
